// @em/blocks — presentational vocabulary the block views need. RSVP status → label
// and Mantine badge colour, copied from the app's EventGuestService so the package
// (and the SSR event website) stay self-contained. These mirror the API boundary's
// EVENT_RSVP_STATUS; keep them in sync if the lifecycle changes.

export const EVENT_RSVP_STATUS_LABELS: Record<string, string> = {
  unknown: 'Not invited',
  invited: 'Invited',
  visited: 'Visited',
  pending: 'Pending',
  approved: 'Going',
  denied: 'Denied',
  maybe: 'Maybe',
  declined: 'Declined',
  waitlisted: 'Waitlisted',
  canceled: 'Canceled',
};

/** Guest-role → label, mirrored from the app's EventGuestService. */
export const EVENT_GUEST_ROLE_LABELS: Record<string, string> = {
  guest: 'Guest',
  buyer: 'Buyer',
  host: 'Host',
  co_host: 'Co-host',
  organizer: 'Organizer',
  staff: 'Staff',
  volunteer: 'Volunteer',
  vendor: 'Vendor',
  speaker: 'Speaker',
  performer: 'Performer',
  other: 'Other',
};

/** Crew roles — everyone who helps run the event (the hosts block). Excludes `guest`
 *  AND `buyer` (a buyer is neither a guest nor crew). Mirrors the app's TEAM_ROLES. */
export const TEAM_ROLES: string[] = ['host', 'co_host', 'organizer', 'staff', 'volunteer', 'vendor', 'speaker', 'performer', 'other'];

/** The roles a people block (guests / hosts) can show: guests, and every crew role. Not `buyer` — bought, not coming. */
export const PEOPLE_BLOCK_ROLES: string[] = ['guest', ...TEAM_ROLES];

/** A Mantine color per RSVP status, for badges. ⚠ Mirrors apps/app `EventGuestService` — kept equal by `check-brand-theme`. */
export const EVENT_RSVP_STATUS_COLORS: Record<string, string> = {
  unknown: 'gray',
  invited: 'blue',
  visited: 'teal',
  pending: 'yellow',
  approved: 'green',
  denied: 'red',
  maybe: 'grape',
  declined: 'orange',
  waitlisted: 'lime',
  canceled: 'dark',
};
